import { PageShell, PolicySection } from "@/components/PageShell";

export default function Terms() {
  return (
    <PageShell
      title="Terms & Conditions"
      testid="terms-page"
      subtitle="Terms governing the use of the Findivine website and online donations. Last updated: July 2026."
    >
      <PolicySection title="1. Website usage">
        <p>
          These Terms & Conditions govern your access to and use of the website of <strong>Findivine</strong>
          (One Kind Earth Foundation), an NGO accepting donations for the welfare of society. By using this website
          or making a donation, you accept these terms. If you do not agree, please do not use the donation
          facilities on this website.
        </p>
      </PolicySection>

      <PolicySection title="2. Nature of donations">
        <p>
          All contributions made through this website are <strong>voluntary donations</strong> intended to support
          Findivine's stated social welfare objectives — women empowerment, animal welfare, child education,
          welfare of economically weaker sections, and Hindu religious empowerment. A donation is not a purchase of
          goods or services, and nothing is sold or supplied to you in return.
        </p>
        <p>
          Where you indicate a preferred cause or campaign while donating, we treat that as your request and
          endeavour to honour it; however, unless explicitly stated otherwise, donations may be applied across our
          stated objectives where the need is greatest.
        </p>
      </PolicySection>

      <PolicySection title="3. Donation process">
        <p>
          Online donations are initiated through the donation form on this website. The donation amount you select
          is displayed to you before payment, and no additional charges are added by Findivine — the amount you
          choose is the amount debited.
        </p>
        <p>
          Payments are processed by third-party payment gateway providers or through UPI. A donation is complete
          only upon successful processing and confirmation by the payment provider. If a transaction fails, remains
          pending, is duplicated, or an incorrect amount is debited, please contact us with the transaction details
          (see our Refund & Cancellation Policy) and we will review it with the payment provider.
        </p>
      </PolicySection>

      <PolicySection title="4. Receipts and acknowledgements">
        <p>
          For donations recorded on our systems, an acknowledgement is sent to the email address you provide. If you
          need a formal receipt or a record of your donations, write to us at{" "}
          <a href="mailto:info@findivine.org" className="text-primary underline underline-offset-2">info@findivine.org</a>{" "}
          with your name, donation date and amount.
        </p>
        <p>
          Please note: this website does not currently claim that donations qualify for tax deduction under Section
          80G or any other provision. If and when applicable registrations are obtained and verified, we will update
          this page and issue appropriate documentation.
        </p>
      </PolicySection>

      <PolicySection title="5. Donor responsibilities">
        <p>
          You agree to provide accurate and truthful information when donating or contacting us, to use only payment
          instruments you are authorised to use, and to keep your acknowledgement emails and transaction references
          for your records.
        </p>
      </PolicySection>

      <PolicySection title="6. Intellectual property">
        <p>
          The content of this website — including text, design, images and the Findivine name — belongs to or is
          used with permission by One Kind Earth Foundation. You may view and share it for personal, non-commercial
          purposes; any other use requires our written consent.
        </p>
      </PolicySection>

      <PolicySection title="7. Fraud and misuse">
        <p>
          We may decline, cancel or report transactions that appear fraudulent, unauthorised or made in error, and
          may cooperate with payment providers, banks and authorities in investigating misuse of the donation
          facilities.
        </p>
      </PolicySection>

      <PolicySection title="8. Third-party payment services">
        <p>
          Payment gateway and UPI services are provided by third parties under their own terms and privacy policies.
          While we take care in selecting providers, Findivine is not responsible for outages, errors or acts of
          these third-party platforms; we will, however, assist you in resolving donation-related issues with them.
        </p>
      </PolicySection>

      <PolicySection title="9. Changes to the website and these terms">
        <p>
          We may update the website, our campaigns and these Terms & Conditions from time to time. The version
          published on this page, with its effective date, is the version in force.
        </p>
      </PolicySection>

      <PolicySection title="10. Complaints and grievances">
        <p>
          For any complaint or grievance about this website, a donation, or a payment, contact us at{" "}
          <a href="mailto:info@findivine.org" className="text-primary underline underline-offset-2">info@findivine.org</a>{" "}
          or{" "}
          <a href="tel:+918875285537" className="text-primary underline underline-offset-2">+91 8875285537</a>.
          We will acknowledge and review genuine concerns as promptly as we can.
        </p>
      </PolicySection>

      <PolicySection title="11. Governing law">
        <p>
          These terms are governed by the laws of India. Nothing in these terms removes any right you may have under
          applicable law.
        </p>
      </PolicySection>

      <PolicySection title="12. Contact">
        <p>
          Findivine — One Kind Earth Foundation
          <br />
          Vaishali Nagar, Jaipur, Rajasthan 302021
          <br />
          Email: <a href="mailto:info@findivine.org" data-testid="terms-email" className="text-primary underline underline-offset-2">info@findivine.org</a>
          <br />
          Mobile: <a href="tel:+918875285537" data-testid="terms-phone" className="text-primary underline underline-offset-2">+91 8875285537</a>
        </p>
      </PolicySection>
    </PageShell>
  );
}
